import React, { useState, useEffect } from "react";
import Papa from "papaparse";
import payoutImage from './OgbImages/payoutSheet.png';

const Results_2025 = () => {

  return (
    <div class="mainContent" style={{padding: "0px"}}>
      <h1>2025 Results - Weekly Skins</h1>
      <div id="GolfParticipants">
        <table class="golfPTable">
          <thead>
            <tr>
              <th colSpan={6}>Weekly Skins - Final</th>
            </tr>
          </thead>
          <tbody>
            <tr>
                <td colSpan={3} style={{backgroundColor: "#ffffcc"}}>Palmer (3 Rounds)</td>
                <td colSpan={3} style={{backgroundColor: "#7aabcc"}}>Jones (2 Rounds)</td>
            </tr>
            <tr>
                <td style={{backgroundColor: "#ffffcc"}}>Hole Number</td>
                <td style={{backgroundColor: "#ffffcc"}}>Score</td>
                <td style={{backgroundColor: "#ffffcc"}}>Name</td>
                <td style={{backgroundColor: "#7aabcc"}}>Hole Number</td>
                <td style={{backgroundColor: "#7aabcc"}}>Score</td>
                <td style={{backgroundColor: "#7aabcc"}}>Name</td>
            </tr>
            <tr>
                <td >1</td>
                <td>4</td>
                <td>Tie</td>
                <td>1</td>
                <td>3</td>
                <td style={{backgroundColor: "#679c80"}}>Bruce</td>
            </tr>
            <tr>
                <td>2</td>
                <td>5</td>
                <td>Tie</td>
                <td>2</td>
                <td>3</td>
                <td style={{backgroundColor: "#679c80"}}>Bruce</td>
            </tr>
            <tr>
                <td>3</td>
                <td>3</td>
                <td>tie</td>
                <td>3</td>
                <td>4</td>
                <td>Tie</td>
            </tr>
            <tr>
                <td>4</td>
                <td>3</td>
                <td style={{backgroundColor: "#679c80"}}>John S</td>
                <td>4</td>
                <td>2</td>
                <td>Tie</td>
            </tr>
            <tr>
                <td>5</td>
                <td>3</td>
                <td>Tie</td>
                <td>5</td>
                <td>5</td>
                <td>Tie</td>
            </tr>
            <tr>
                <td>6</td>
                <td>4</td>
                <td>Tie</td>
                <td>6</td>
                <td>4</td>
                <td>Tie</td>
            </tr>
            <tr>
                <td>7</td>
                <td>3</td>
                <td>Tie</td>
                <td>7</td>
                <td>2</td>
                <td style={{backgroundColor: "#679c80"}}>Carl E</td>
            </tr>
            <tr>
                <td>8</td>
                <td>5</td>
                <td>Tie</td>
                <td>8</td>
                <td>4</td>
                <td>Tie</td>
            </tr>
            <tr>
                <td>9</td>
                <td>2</td>
                <td>Tie</td>
                <td>9</td>
                <td>4</td>
                <td>Tie</td>
            </tr>
            <tr>
                <td>10</td>
                <td>2</td>
                <td style={{backgroundColor: "#679c80"}}>Gregg B</td>
                <td>10</td>
                <td>4</td>
                <td>Tie</td>
            </tr>
            <tr>
                <td>11</td>
                <td>5</td>
                <td>Tie</td>
                <td>11</td>
                <td>2</td>
                <td style={{backgroundColor: "#679c80"}}>Brian</td>
            </tr>
            <tr>
                <td>12</td>
                <td>3</td>
                <td>Tie</td>
                <td>12</td>
                <td>4</td>
                <td>Tie</td>
            </tr>
            <tr>
                <td>13</td>
                <td>2</td>
                <td>Tie</td>
                <td>13</td>
                <td>3</td>
                <td>Tie</td>
            </tr>
            <tr>
                <td>14</td>
                <td>4</td>
                <td style={{backgroundColor: "#679c80"}}>Randy D</td>
                <td>14</td>
                <td>4</td>
                <td style={{backgroundColor: "#679c80"}}>John S</td>
            </tr>
            <tr>
                <td>15</td>
                <td>2</td>
                <td>Tie</td>
                <td>15</td>
                <td>3</td>
                <td>Tie</td>
            </tr>
            <tr>
                <td>16</td>
                <td>4</td>
                <td>Tie</td>
                <td>16</td>
                <td>4</td>
                <td>Tie</td>
            </tr>
            <tr>
                <td>17</td>
                <td>2</td>
                <td style={{backgroundColor: "#679c80"}}>Brian B</td>
                <td>17</td>
                <td>4</td>
                <td>Tie</td>
            </tr>
            <tr>
                <td>18</td>
                <td>3</td>
                <td>Tie</td>
                <td>18</td>
                <td>4</td>
                <td>Tie</td>
            </tr>
            <tr>
                <td>Pot</td>
                <td>$67.00</td>
                <td></td>
                <td>Pot</td>
                <td>$47.00</td>
                <td></td>
            </tr>
            <tr>
                <td># of Skins</td>
                <td>4</td>
                <td style={{border: "0px"}}></td>
                <td># of Skins</td>
                <td>5</td>
                <td style={{border: "0px"}}></td>
            </tr>
            <tr>
                <td>$ / Skin</td>
                <td>$16.75</td>
                <td style={{border: "0px"}}></td>
                <td>$ / Skin</td>
                <td>$9.40</td>
                <td style={{border: "0px"}}></td>
            </tr>
          </tbody>
        </table>
      </div>
      <h1 style={{paddingTop: "100px"}}>2025 Results - Total $ for the Week</h1>
      <div id="GolfParticipants">
        <img src={payoutImage} style={{width: "100%"}}></img>
        {/* <table class="golfPTable">
          <thead>
            <tr>
              <th>Player</th>
              <th style={{backgroundColor: "#679c80"}}>Total $ for the Week</th>
            </tr>
          </thead>
          <tbody>
            <tr>
                <td>Baumgartner, Mike</td>
                <td>$99.57</td>
            </tr>
            <tr>
                <td>Baumgartner, Gregg</td>
                <td>$54.99</td>
            </tr>
            <tr>
                <td>Martin, Eric</td>
                <td>$24.29</td>
            </tr>
            <tr>
                <td>Uturo, Eric</td>
                <td>$47.08</td>
            </tr>
            <tr>
                <td>Dahler, Dave</td>
                <td>$29.80</td>
            </tr>
            <tr>
                <td>Slisko, Jim</td>
                <td>$39.05</td>
            </tr>
            <tr>
                <td>Steven, John</td>
                <td>$80.54</td>
            </tr>
            <tr>
                <td>Cathcart, Dan</td>
                <td>$14.56</td>
            </tr>
            <tr>
                <td>Dewalt, Randy</td>
                <td>$45.55</td>
            </tr>
            <tr>
                <td>Applegate, Tim</td>
                <td>$41.80</td>
            </tr>
            <tr>
                <td>Moffett, Gregg</td>
                <td>$48.25</td>
            </tr>
            <tr>
                <td>Baumgartner, Brian</td>
                <td>$73.21</td>
            </tr>
            <tr>
                <td>Baumgartner, Steve</td>
                <td>$49.78</td>
            </tr>
            <tr>
                <td>Rocco, Bob</td>
                <td>$38.34</td>
            </tr>
            <tr>
                <td>Zawada, Jeff</td>
                <td>$8.56</td>
            </tr>
            <tr>
                <td>Leitch, Paul</td>
                <td>$13.25</td>
            </tr>
            <tr>
                <td>Delehanty, John</td>
                <td>$19.34</td>
            </tr>
            <tr>
                <td>Delehanty, Jim</td>
                <td>$15.59</td>
            </tr>
            <tr>
                <td>Shymske, Dave</td>
                <td>$8.00</td>
            </tr>
            <tr>
                <td>Wallace, Randy</td>
                <td>$22.95</td>
            </tr>
            <tr>
                <td>Kennedy, Curt</td>
                <td>$23.19</td>
            </tr>
            <tr>
                <td>Rose, Rick</td>
                <td>$14.00</td>
            </tr>
            <tr>
                <td>Rosler, Vance</td>
                <td>$28.03</td>
            </tr>
            <tr>
                <td>Rogers, Bobo</td>
                <td>$19.10</td>
            </tr>
            <tr>
                <td>Stiver, Bruce</td>
                <td>$136.41</td>
            </tr>
            <tr>
                <td>Erb, Carl</td>
                <td>$67.02</td>
            </tr>
            <tr>
                <td>Shinn, Al</td>
                <td>$36.50</td>
            </tr>
            <tr>
                <td>Shindeldecker, Larry</td>
                <td>$15.91</td>
            </tr>
            <tr>
                <td>Gossett, Marvin</td>
                <td>$29.00</td>
            </tr>
            <tr>
                <td>Miller, Patrick</td>
                <td>$20.35</td>
            </tr>
            <tr>
                <td style={{backgroundColor: "#679c80"}}>Total $</td>
                <td style={{backgroundColor: "#679c80"}}>$1,164.00</td>
            </tr>
          </tbody>
        </table> */}
      </div>
    </div>
  );
};
  
export default Results_2025;